import { createSelector } from '@reduxjs/toolkit';
import { StoreState, AllDocumentTypes } from 'types';

const getFileIds = (state: StoreState) => state.docManager.fileIds;

export const getFileId = (documentType: AllDocumentTypes) =>
  createSelector([getFileIds], fileIds => fileIds.find(entry => entry.documentType === documentType));
